<pc-image-banner 
    [imgUrl]="this.bannerImgUrl || ''"
>
</pc-image-banner>

<div class="site-gutter white-gutter">
    <div class="main-copy-section">
        <div class="wrapper">
            <div class="copy-container">
                <div class="header-container">
                    <h1>Division 10</h1>
                    <h2>Specialties</h2>
                </div>
                <p>
                    Division 10 (Specialties) encompasses specialized, prefabricated building components not covered by other construction divisions. P.C. Haines can provide a security-focused element with Ballistic Resistant Panels (CSI 10 26 41), which provide critical protection in high-risk environments like banks, government facilities, and schools. These panels undergo rigorous testing against standards with varying protection levels.
                </p>
            </div>
            <div class="circles services-circles">
                <pc-services-circles></pc-services-circles>
            </div>
        </div>
    </div>
</div>

<div class="secondary-content-section dark-section">
    <div class="site-gutter">
        <div class="card-container">
            <div class="card-row">
                <div class="card numbered-card">
                    <div class="header-container">
                        <div class="number-header">
                            <span class="number">1</span>
                            <h3>Ballistic Resistant Panels</h3>
                        </div>
                    </div>
                    <p>Ballistic Resistant Panels (CSI Division 10, 102641) offer state-of-the-art protection against armed threats. Designed for critical facilities such as government buildings, schools, financial institutions, and healthcare centers, our panels combine cutting-edge materials—like hardened steel, UL-certified composites, and transparent bullet-resistant glass—with rigorous compliance to ASTM F1233 and UL 752 standards. Trust our solutions to safeguard lives and assets without compromising on architectural aesthetics.</p>
                </div>
                <div class="card">
                </div>
            </div>
        </div>
    </div>
</div>

<pc-seat-belt
    [copy]="'Ready to experience the PC Haines difference? Submit a bid request today.'"
    [buttonText]="'Submit a Request'"
    [buttonUrl]="'/contact-us'"
    [urlFragment]="'bid-request'"
></pc-seat-belt>